import { ChevronLeft } from 'lucide-react'
import { Link } from 'react-router'

export function BackLink({ to, label }: { to: string; label: string }) {
  return (
    <Link to={to} className="text-muted-foreground hover:text-ink flex h-10 w-fit items-center gap-1 text-sm">
      <ChevronLeft className="size-4" />
      {label}
    </Link>
  )
}
